import type { JobCluster } from '~/shared/data-contract/job-cluster';
import type { JobFamily } from '~/shared/data-contract/job-family';

/** added/removed = pending user accept; confirmed = from backend; accepted = user approved addition, not yet saved; updated = from backend with local edits to patch */
export type ReviewItemStatus = 'accepted' | 'added' | 'confirmed' | 'removed' | 'updated';

export const isTemporaryDraftItem = (status: ReviewItemStatus): boolean => status === 'added' || status === 'accepted';

export const isPendingReviewItem = (status: ReviewItemStatus): boolean =>
    status === 'added' || status === 'removed' || status === 'updated';
export const isSelectableReviewItem = (status: ReviewItemStatus): boolean => status === 'added' || status === 'removed';

export type DraftFamilyRow = {
    readonly id: string;
    readonly data: JobFamily;
    readonly level: 0;
    readonly name: string;
    readonly status: ReviewItemStatus;
    readonly subRows?: readonly DraftClusterRow[];
    readonly type: 'family';
};

export type DraftClusterRow = {
    readonly id: string;
    readonly data: JobCluster;
    readonly level: 1;
    readonly name: string;
    readonly parentId: string;
    readonly status: ReviewItemStatus;
    readonly subRows?: never;
    readonly type: 'cluster';
};

export type DraftTableRow = DraftClusterRow | DraftFamilyRow;
